import React, { createContext, useState } from 'react';
import { apiEndpoints } from '@selfserve/react-utils';
import { storage, storageKeys, useStorage } from '@selfserve/react-hooks';

const MarketingInfoContext = createContext({ tokenContext: '', setTokenContext: (t: string) => {},
  raiseAnalyticEventsRequest: (eventName:string) => {} });

export const MarketingInfoProvider = ({ children }: { children: React.ReactNode }) => {
  const [eventNamesQ, setEventNamesQ] = useState([] as Array<string>);
  const [accessToken] = useStorage(
    storage.SESSION,
    storageKeys.TOKEN
  );
  const [tokenContext, setTokenContext] = useState('');
  const raiseAnalyticEventsRequest = (eventName: string,) => {
    const newQ = [...eventNamesQ, eventName];
    setEventNamesQ(newQ);
    if (tokenContext || accessToken) {
      for (const eventNameInQ of newQ) {
        const url = apiEndpoints.raiseAnalyticEvents.replace(':name', eventNameInQ);
        fetch(url, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        });
      }
      setEventNamesQ([]);
    }
    else{
      console.log("accessToken does not exist yet ");
    }
    return;
  };
  return (
    <MarketingInfoContext.Provider value={{ tokenContext, setTokenContext, raiseAnalyticEventsRequest }}>
      {children}
    </MarketingInfoContext.Provider>
  );
};

export default MarketingInfoContext;
